module.exports = {
  siteTitle: 'Khushal Agarwal | Software Engineer',
  siteDescription:
    'Hello! I am a software developer majoring Bachelor\'s in Technology, Computer Science and Engineering. I have skills in MERN stack development with experience in React,React native, Vue, JavaScript, NodeJS. I am a competitive programmer with skills in data structure and functional programming.',
  siteKeywords:
    'Khushal Agarwal | Software Engineer | Web Developer | Android Developer | JavaScript Developer',
  siteUrl: 'https://khushalagarwal.com',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-171154783-2',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',
  name: 'Khushal Agarwal',
  location: 'Raiganj, India',
  email: 'khushal.agarwal987@gmail.com',
  github: 'https://github.com/khushal87',
  twitterHandle: '@khushal_70',
  about: {
    title: 'About Me',
    desc:
      'Hi! I am Khushal Agarwal, a software engineer based in Raiganj,India. \n I have been working in Javascript since a long time which fascinates me towards the frameworks such as React,React Native and VueJS. React,React Native helps me build scalable applications in Web,Android and IOS devices. I have a fair command in data structures and algorithms which helps me write cleaner and faster solutions.',
    skills: [
      'React',
      'React Native',
      'VueJS',
      'NodeJS',
      'JavaScript (ES6+)',
      'HTML/(S)CSS',
      'Competitive Programmer',
      'Data Structures and Algorithms',
    ],
  },
  work: [
    {
      role: 'Software Engineer',
      url: 'farziengineer.com',
      title: 'FarziEngineer',
      time: 'October,2019 - Present',
      desc: [
        'Socbays -  A react native application which serves all the soccer/football sporting needs. Allows you to create your own challenges and play a match',
        'Aspen nannies Admin panel - A React based aplication serving the order and employee details of a renowned firm aspen nannies in Colorado,USA',
      ],
    },
    {
      role: 'Software Developer Intern',
      url: 'www.ritsolution.in',
      title: 'RIT Solution',
      time: 'August,2019 - December,2019',
      desc: ['Secure Blink - A cyber security dashboard built on React'],
    },
  ],
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/khushal87',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/khushal-agarwal-547370166/',
    },
    {
      name: 'Repl.it',
      url: 'https://repl.it/@khushal87',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/khushal.agarwal_70/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/khushal_70',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
